/* Keepsake Lines · premium v2 helpers. Does not touch kl-theme.js logic. */
(function () {
  'use strict';

  /* "Add to cart · price": mirror the live price that kl-theme.js writes into [data-kl-pprice] [data-now] */
  function syncAtc() {
    var now = document.querySelector('[data-kl-pprice] [data-now]');
    if (!now) return;
    var txt = (now.textContent || '').trim();
    if (!txt) return;
    document.querySelectorAll('[data-kl-atc-price]').forEach(function (el) {
      if (el.closest('product-card, .product-card')) return;
      var cur = el.getAttribute('data-kl-price');
      if (cur === txt) return;
      el.setAttribute('data-kl-price', txt);
      el.innerHTML = '<span aria-hidden="true">·</span> ' + txt;
    });
  }

  /* Delivery estimate in the shopper's local date: <x data-kl-eta="5,12"> */
  function paintEta(scope) {
    (scope || document).querySelectorAll('[data-kl-eta]').forEach(function (el) {
      var p = String(el.getAttribute('data-kl-eta') || '').split(',');
      var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
      if (!(a > 0) || !(b >= a)) return;
      var d1 = new Date(), d2 = new Date();
      d1.setDate(d1.getDate() + a);
      d2.setDate(d2.getDate() + b);
      try {
        var o = { month: 'short', day: 'numeric' };
        var t = d1.getMonth() === d2.getMonth()
          ? d1.toLocaleDateString('en-US', o) + '–' + d2.getDate()
          : d1.toLocaleDateString('en-US', o) + ' – ' + d2.toLocaleDateString('en-US', o);
        if (el.textContent !== t) el.textContent = t;
      } catch (e) {}
    });
  }

  var t = null;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () { syncAtc(); paintEta(); }, 60);
  }

  function start() {
    syncAtc();
    paintEta();
    try {
      /* price text changes (variant switch) and drawer / section re-renders (morphs) */
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          var el = n.nodeType === 1 ? n : n.parentElement;
          if (!el) continue;
          if (el.closest('[data-kl-pprice], [data-kl-atc-price], #cart-drawer, .add-to-cart-button') || muts[i].addedNodes.length) { refresh(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    document.addEventListener('shopify:product:select', refresh, true);
    document.addEventListener('shopify:cart:lines-update', refresh);
    document.addEventListener('cart:update', refresh);
  }

  /* Sticky add-to-cart bar (desktop + mobile): Horizon "puppet-clicks" the main button, which skips the
     Teeinblue personalisation (photo + properties) and adds nothing. Instead, bring the main button into
     view and click it for real, so Teeinblue validation and properties apply. */
  function mainAtc(from) {
    var scope = (from && from.closest('.shopify-section')) || document;
    var list = scope.querySelectorAll('product-form-component button[name="add"], form[action*="/cart/add"] button[name="add"]');
    var fallback = null;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.closest('sticky-add-to-cart, product-card, .product-card, dialog')) continue;
      if (b.offsetParent !== null) return b;
      if (!fallback) fallback = b;
    }
    return fallback;
  }
  window.addEventListener('click', function (e) {
    var s = e.target && e.target.closest && e.target.closest('.sticky-add-to-cart__button');
    if (!s || s.disabled) return;
    var main = mainAtc(s);
    if (!main) return; // no main form found: leave Horizon's behaviour
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
    try { main.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (err) { main.scrollIntoView(); }
    setTimeout(function () {
      if (main.disabled) return;
      try { main.focus({ preventScroll: true }); } catch (err) {}
      main.click();
    }, reduce ? 0 : 450);
  }, true);

  /* Teeinblue modals (photo cropper, preview lightbox) must never sit under Horizon's sticky bar:
     while one is open the bar is hidden (class on <html> + hidePopover if it is in the top layer). */
  var TEE_SEL = '[class*="cropper"], [class*="tee-"][class*="modal"], [class*="tee-"][class*="popup"], [class*="tee-"][class*="lightbox"], [class*="teeinblue"][class*="modal"], [class*="teeinblue"][class*="popup"], [class*="teeinblue"][class*="lightbox"], [class*="tee-"] [class*="modal"], [class*="teeinblue"] [class*="modal"], [class*="tee-"] [class*="lightbox"], [class*="teeinblue"] [class*="lightbox"]';
  function isShown(el) {
    if (!el || el === document.documentElement || el === document.body || el.closest('sticky-add-to-cart')) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 150 || r.height < 150) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
  }
  var teeOpen = false, reopenBars = [];
  function checkTee() {
    var open = false;
    try {
      var list = document.querySelectorAll(TEE_SEL);
      for (var i = 0; i < list.length; i++) { if (isShown(list[i])) { open = true; break; } }
    } catch (e) {}
    if (open === teeOpen) return;
    teeOpen = open;
    document.documentElement.classList.toggle('kl-tbmodal-open', open);
    document.querySelectorAll('.sticky-add-to-cart__bar').forEach(function (bar) {
      try {
        if (open && bar.matches(':popover-open')) { bar.hidePopover(); reopenBars.push(bar); }
      } catch (e) {}
    });
    if (!open) {
      reopenBars.forEach(function (bar) {
        try { if (bar.isConnected && bar.dataset.stuck === 'true' && !bar.matches(':popover-open')) bar.showPopover(); } catch (e) {}
      });
      reopenBars = [];
    }
  }
  var teeT = null;
  function queueTee() { clearTimeout(teeT); teeT = setTimeout(checkTee, 80); }
  function startTee() {
    if (!document.querySelector('sticky-add-to-cart')) return;
    try {
      new MutationObserver(queueTee).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
    } catch (e) {}
    document.addEventListener('click', queueTee, true);
    document.addEventListener('touchend', queueTee, true);
    queueTee();
  }

  /* ---------- PDP gallery: keep the Teeinblue live preview + add the product photos as thumbnails ----------
     1) Horizon's <media-gallery> replaces itself with the freshly rendered gallery on every option click.
        Teeinblue mounts its live preview inside it, so that wiped the preview + thumbnails (and made the
        page jump ~100px). While a Teeinblue gallery is inside, the replacement is skipped (Teeinblue
        switches the mockup for the chosen frame itself). Products without Teeinblue keep Horizon's behaviour.
     2) The product's own Shopify photos are appended as static thumbnails to Teeinblue's strip; tapping one
        shows that photo over the main image; tapping a mockup, an arrow or changing an option goes back. */
  function hasTee(el) { return !!(el && el.querySelector && el.querySelector('#tee-gallery, .tee-gallery-content, .tee-gallery')); }
  function guardGallery() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('media-gallery').then(function () {
      var C = customElements.get('media-gallery');
      if (!C || C.prototype.__klGuard) return;
      C.prototype.__klGuard = true;
      var orig = C.prototype.replaceWith || Element.prototype.replaceWith;
      C.prototype.replaceWith = function () {
        if (hasTee(this)) return;
        return orig.apply(this, arguments);
      };
    }).catch(function () {});
  }
  guardGallery();

  var gxImgs = null;
  function productPhotos() {
    if (gxImgs) return gxImgs;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return (gxImgs = Promise.resolve([]));
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    gxImgs = fetch(root + 'products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        return (p.media || []).filter(function (x) { return x && x.media_type === 'image' && x.src; })
          .map(function (x) { return { src: x.src, alt: x.alt || p.title || '' }; });
      })
      .catch(function () { return []; });
    return gxImgs;
  }
  function imgUrl(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function gxFit(g) {
    var tt = g.querySelector('.tee-thumbnails');
    if (!tt) return;
    var first = tt.querySelector('.tee-thumbnail');
    var native = (first && parseFloat(first.style.width)) || 90;
    var n = tt.querySelectorAll('.tee-thumbnail, .kl-gx-thumb').length || 1;
    var W = tt.getBoundingClientRect().width || g.getBoundingClientRect().width || 375;
    var gap = 6, min = W < 600 ? 64 : 72, max = W < 600 ? 96 : 104;
    var s = Math.floor(Math.max(min, Math.min(max, (W - (n - 1) * gap) / n)));
    g.style.setProperty('--kl-gx-s', s + 'px');
    g.style.setProperty('--kl-gx-k', String(s / native));
    g.style.setProperty('--kl-gx-gap', gap + 'px');
  }
  function gxActive(g, idx) {
    g.querySelectorAll('.kl-gx-thumb').forEach(function (b) {
      b.setAttribute('aria-current', String(b.getAttribute('data-kl-gx') === String(idx)));
    });
  }
  function gxShow(g, i) {
    productPhotos().then(function (imgs) {
      var im = imgs[i], v = g.querySelector('.kl-gx-view');
      if (!im || !v) return;
      var img = v.querySelector('img');
      img.alt = im.alt;
      img.sizes = '(min-width: 750px) 50vw, 100vw';
      img.srcset = [600, 1000, 1600].map(function (w) { return imgUrl(im.src, w) + ' ' + w + 'w'; }).join(', ');
      img.src = imgUrl(im.src, 1000);
      v.hidden = false;
      void v.offsetWidth;
      v.classList.add('is-on');
      g.classList.add('kl-gx--ext');
      gxActive(g, i);
    });
  }
  function gxHide(g) {
    if (!g || !g.classList.contains('kl-gx--ext')) return;
    var v = g.querySelector('.kl-gx-view');
    g.classList.remove('kl-gx--ext');
    gxActive(g, -1);
    if (v) { v.classList.remove('is-on'); setTimeout(function () { if (!v.classList.contains('is-on')) v.hidden = true; }, 220); }
  }
  function gxBuild(g, imgs) {
    var tt = g.querySelector('.tee-thumbnails'), stage = g.querySelector('.tee-gallery__stage');
    if (!tt || !stage) return;
    if (!tt.querySelector('.kl-gx-thumbs')) {
      var strip = document.createElement('div');
      strip.className = 'kl-gx-thumbs';
      imgs.forEach(function (im, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kl-gx-thumb';
        b.setAttribute('data-kl-gx', String(i));
        b.setAttribute('aria-current', 'false');
        b.setAttribute('aria-label', 'Show product photo ' + (i + 1));
        var img = document.createElement('img');
        img.src = imgUrl(im.src, 240);
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 120; img.height = 120;
        b.appendChild(img);
        strip.appendChild(b);
      });
      tt.appendChild(strip);
    }
    if (!stage.querySelector('.kl-gx-view')) {
      var v = document.createElement('div');
      v.className = 'kl-gx-view';
      v.hidden = true;
      v.innerHTML = '<img alt="" decoding="async">';
      stage.appendChild(v);
    }
    g.classList.add('kl-gx');
    gxFit(g);
  }
  var gxT = null;
  function gxScan() {
    clearTimeout(gxT);
    gxT = setTimeout(function () {
      var list = Array.prototype.filter.call(document.querySelectorAll('media-gallery'), function (g) {
        return !g.closest('product-card, .product-card, dialog') && g.querySelector('.tee-thumbnails') && g.querySelector('.tee-gallery__stage');
      });
      if (!list.length) return;
      productPhotos().then(function (imgs) {
        if (!imgs.length) return;
        list.forEach(function (g) {
          if (!g.querySelector('.kl-gx-thumbs') || !g.querySelector('.kl-gx-view')) gxBuild(g, imgs);
          else gxFit(g);
        });
      });
    }, 80);
  }
  function startGx() {
    if (!/\/products\//.test(location.pathname)) return;
    try { new MutationObserver(gxScan).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('resize', gxScan);
    gxScan();
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var b = t.closest('.kl-gx-thumb');
      var g = t.closest('media-gallery.kl-gx');
      if (b && g) { e.preventDefault(); gxShow(g, parseInt(b.getAttribute('data-kl-gx'), 10) || 0); return; }
      if (g && t.closest('.tee-thumbnail, .tee-slider__button, .tee-thumbnails__button')) gxHide(g);
    }, true);
    var x0 = null;
    document.addEventListener('touchstart', function (e) {
      x0 = e.target && e.target.closest && e.target.closest('.kl-gx-view') && e.touches[0] ? e.touches[0].clientX : null;
    }, { passive: true, capture: true });
    document.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) document.querySelectorAll('media-gallery.kl-gx--ext').forEach(gxHide);
    }, { passive: true, capture: true });
    function backToPreview(e) {
      var t = e.target;
      if (!t || !t.closest || t.closest('media-gallery, product-card, .product-card')) return;
      if (t.closest('variant-picker') || t.closest('[class*="tee"], [id*="tee"], [class*="teeinblue"]')) {
        document.querySelectorAll('media-gallery.kl-gx--ext').forEach(gxHide);
      }
    }
    document.addEventListener('change', backToPreview, true);
    document.addEventListener('input', backToPreview, true);
    /* Selected options -> matching live mockup. With the 5 Teeinblue mockups (order: 1 White frame, 2 Black frame,
       3 Canvas, 4 Fine-art print / Digital, 5 Natural oak) the index comes from Format + Frame; with exactly one
       mockup per Frame value the old Frame order is kept. Runs after kl-theme.js auto-jumps; no-op if Teeinblue
       already shows that mockup (or switched it itself) or if the mockup count matches neither layout. */
    var syncT = null;
    function optVal(name) {
      var el = document.querySelector('.product-details variant-picker input[data-option-name="' + name + '"]:checked');
      if (el) return String(el.value || '');
      var sel = document.querySelector('.product-details variant-picker select[data-option-name="' + name + '"], .product-details variant-picker select[name*="' + name + '"]');
      return sel ? String(sel.value || '') : '';
    }
    function mockupIndex(count) {
      var fmt = optVal('Format'), frame = optVal('Frame');
      if (count === 5) {
        if (/canvas/i.test(fmt)) return 2;
        if (/fine|print|digital|file/i.test(fmt)) return 3;
        if (/white/i.test(frame)) return 0;
        if (/black/i.test(frame)) return 1;
        if (/oak|natural|wood/i.test(frame)) return 4;
        if (/no frame/i.test(frame)) return 3;
        return -1;
      }
      var any = document.querySelector('.product-details variant-picker input[data-option-name="Frame"]');
      if (!any || !any.closest('fieldset')) return -1;
      var inputs = Array.prototype.slice.call(any.closest('fieldset').querySelectorAll('input[data-option-name="Frame"]'));
      if (count !== inputs.length) return -1;
      var idx = -1;
      inputs.forEach(function (n, i) { if (n.checked) idx = i; });
      return idx;
    }
    function syncMockup() {
      clearTimeout(syncT);
      syncT = setTimeout(function () {
        var g = document.querySelector('media-gallery.kl-gx');
        if (!g) return;
        var tt = g.querySelectorAll('.tee-thumbnails .tee-thumbnail');
        var idx = mockupIndex(tt.length);
        if (idx < 0 || !tt[idx] || tt[idx].classList.contains('tee-thumbnail--active')) return;
        tt[idx].click();
      }, 350);
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('variant-picker') && !t.closest('product-card, .product-card, dialog')) syncMockup();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
    document.addEventListener('DOMContentLoaded', startTee);
    document.addEventListener('DOMContentLoaded', startGx);
  } else { start(); startTee(); startGx(); }
})();

/* ---------- PDP zoom lightbox (19 Oct, round 5) ----------
   Click / tap on the main gallery image (Teeinblue live mockup or one of our product photos in .kl-gx-view)
   or on the round magnifier button opens a full-screen viewer.
   Desktop: click toggles 2.5x, the zoomed image follows the mouse; Esc / close / backdrop closes.
   Touch: pinch (1-4x), drag to pan, double-tap toggles 2.5x.
   The Teeinblue mockup is cloned (computed styles inlined, canvases copied) so the 1.45 crop + watermark match.
   Also tags Teeinblue's "I've checked my preview" checkbox row so kl-patch.css can make it small. */
(function () {
  'use strict';
  if (window.__klZoom) return;
  window.__klZoom = true;
  if (!/\/products\//.test(location.pathname)) return;

  var STAGE = '.tee-gallery__stage';
  var SKIP = 'product-card, .product-card, dialog, .kl-zm, .tee-thumbnails';
  var CONTROLS = 'button:not(.kl-zm-btn), a, input, select, textarea, label, [role="button"], .tee-thumbnails, .tee-thumbnail, [class*="slider__button"], [class*="arrow"], [class*="pagination"], [class*="dots"], [class*="cropper"]';
  var ZOOM = 2.5, MIN = 1, MAX = 4;
  var ICON_ZOOM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L20 20M10.5 8v5M8 10.5h5"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var PROPS = ['display', 'position', 'top', 'right', 'bottom', 'left', 'width', 'height', 'min-width', 'min-height', 'max-width', 'max-height',
    'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'box-sizing', 'overflow-x', 'overflow-y', 'transform', 'transform-origin', 'translate', 'scale', 'rotate', 'opacity', 'visibility', 'z-index', 'isolation',
    'background-color', 'background-image', 'background-size', 'background-position', 'background-repeat', 'object-fit', 'object-position',
    'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius',
    'border-top', 'border-right', 'border-bottom', 'border-left', 'box-shadow', 'mix-blend-mode', 'filter', 'clip-path',
    'mask-image', '-webkit-mask-image', 'mask-size', '-webkit-mask-size', 'mask-position', '-webkit-mask-position', 'mask-repeat', '-webkit-mask-repeat',
    'flex-direction', 'flex-wrap', 'justify-content', 'align-items', 'align-self', 'flex-grow', 'flex-shrink', 'flex-basis', 'order', 'float',
    'font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing', 'text-align', 'white-space', 'color', 'aspect-ratio'];

  function reduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function mainStage(el) { var s = el && el.closest && el.closest(STAGE); return s && !s.closest('product-card, .product-card, dialog, .kl-zm') ? s : null; }

  /* ---- affordance button on every main stage ---- */
  function addButtons() {
    document.querySelectorAll(STAGE).forEach(function (s) {
      if (s.closest('product-card, .product-card, dialog, .kl-zm')) return;
      if (s.querySelector(':scope > .kl-zm-btn')) return;
      try { if (getComputedStyle(s).position === 'static') s.style.position = 'relative'; } catch (e) {}
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kl-zm-btn';
      b.setAttribute('aria-label', 'Zoom image');
      b.innerHTML = ICON_ZOOM;
      s.appendChild(b);
    });
  }

  /* ---- Teeinblue confirmation checkbox: tag it for the small/quiet style ---- */
  var CONFIRM_RE = /checked my preview/i;
  function tagConfirm() {
    if (document.querySelector('.kl-tb-confirm')) return;
    var roots = document.querySelectorAll('[class*="teeinblue"], [id*="teeinblue"], [class*="tee-"], form[action*="/cart/add"]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.closest('product-card, .product-card, .kl-zm') || !CONFIRM_RE.test(root.textContent || '')) continue;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (!CONFIRM_RE.test(n.nodeValue || '')) continue;
        var txt = n.parentElement;
        if (!txt || txt.closest('.kl-tb-confirm')) continue;
        var label = txt.closest('label') || txt;
        var box = label.querySelector('input[type="checkbox"]');
        if (!box && label.htmlFor) box = document.getElementById(label.htmlFor);
        var row = label, up = 0;
        while (!box && row.parentElement && up < 3) { row = row.parentElement; up++; box = row.querySelector('input[type="checkbox"]'); }
        label.classList.add('kl-tb-confirm');
        if (box) {
          box.classList.add('kl-tb-confirm__box');
          var p = label.contains(box) ? label : row;
          p.classList.add('kl-tb-confirm-row');
        }
      }
      return;
    }
  }

  /* ---- lightbox ---- */
  var ov, box, pan, hint, closeBtn, lastFocus = null, isOpen = false, htmlOverflow = '';
  var Z = { s: 1, tx: 0, ty: 0 }, BW = 0, BH = 0, src = null;

  function build() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'kl-zm';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Zoomed image');
    ov.innerHTML = '<div class="kl-zm__box"><div class="kl-zm__pan"></div></div>' +
      '<button type="button" class="kl-zm__close" aria-label="Close zoom">' + ICON_CLOSE + '</button>' +
      '<p class="kl-zm__hint" aria-hidden="true"></p>';
    box = ov.querySelector('.kl-zm__box');
    pan = ov.querySelector('.kl-zm__pan');
    hint = ov.querySelector('.kl-zm__hint');
    closeBtn = ov.querySelector('.kl-zm__close');
    document.body.appendChild(ov);
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    ov.addEventListener('click', function (e) {
      if (e.target === ov) close(); /* backdrop only */
    });
    ov.addEventListener('pointerdown', onDown);
    ov.addEventListener('pointermove', onMove);
    ov.addEventListener('pointerup', onUp);
    ov.addEventListener('pointercancel', onUp);
    ov.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') onUp(e); });
    ov.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* iOS Safari: block its own page pinch / double-tap zoom while the viewer is open */
    ov.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    ov.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
  }

  function apply(mode) {
    pan.classList.toggle('is-anim', mode === 'anim' && !reduced());
    pan.classList.toggle('is-follow', mode === 'follow' && !reduced());
    pan.style.transform = 'translate3d(' + Z.tx.toFixed(1) + 'px,' + Z.ty.toFixed(1) + 'px,0) scale(' + Z.s.toFixed(3) + ')';
    ov.classList.toggle('is-zoomed', Z.s > 1.01);
  }
  function clampT() {
    var mx = BW * (Z.s - 1) / 2, my = BH * (Z.s - 1) / 2;
    Z.tx = clamp(Z.tx, -mx, mx);
    Z.ty = clamp(Z.ty, -my, my);
  }
  function reset(mode) { Z.s = 1; Z.tx = 0; Z.ty = 0; apply(mode); }
  /* zoom to s keeping the screen point (cx, cy) fixed */
  function zoomAt(s, cx, cy, mode) {
    var r = box.getBoundingClientRect();
    var dx = cx - (r.left + r.width / 2), dy = cy - (r.top + r.height / 2);
    var px = (dx - Z.tx) / Z.s, py = (dy - Z.ty) / Z.s;
    Z.s = s;
    Z.tx = dx - px * s;
    Z.ty = dy - py * s;
    clampT();
    apply(mode);
  }
  function follow(cx, cy) {
    var r = box.getBoundingClientRect();
    var rx = clamp((cx - r.left) / r.width, 0, 1), ry = clamp((cy - r.top) / r.height, 0, 1);
    Z.tx = (0.5 - rx) * BW * (Z.s - 1);
    Z.ty = (0.5 - ry) * BH * (Z.s - 1);
    apply('follow');
  }

  /* pointer handling */
  var pts = {}, nPts = 0, g = null, tap = null, lastTap = null;
  function inBox(x, y) { var r = box.getBoundingClientRect(); return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; }
  function list() { var a = []; for (var k in pts) a.push(pts[k]); return a; }
  function startGesture() {
    var a = list();
    if (a.length >= 2) {
      var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1;
      g = { pinch: true, d0: d, s0: Z.s, mx: (a[0].x + a[1].x) / 2, my: (a[0].y + a[1].y) / 2, tx0: Z.tx, ty0: Z.ty };
    } else if (a.length === 1) {
      g = { pinch: false, x0: a[0].x, y0: a[0].y, tx0: Z.tx, ty0: Z.ty };
    } else g = null;
  }
  function onDown(e) {
    if (!isOpen || e.target.closest('.kl-zm__close')) return;
    if (e.pointerType === 'mouse') {
      if (e.button !== 0) return;
      tap = { x: e.clientX, y: e.clientY, t: Date.now(), moved: false, mouse: true };
      return;
    }
    try { ov.setPointerCapture(e.pointerId); } catch (err) {}
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    nPts = list().length;
    if (nPts === 1) tap = { x: e.clientX, y: e.clientY, t: Date.now(), moved: false };
    else if (tap) tap.moved = true;
    startGesture();
  }
  function onMove(e) {
    if (!isOpen) return;
    if (e.pointerType === 'mouse') {
      if (tap && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) > 6) tap.moved = true;
      if (Z.s > 1.01) follow(e.clientX, e.clientY);
      return;
    }
    if (!pts[e.pointerId]) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (tap && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) > 8) tap.moved = true;
    if (!g) return;
    var a = list(), r = box.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    if (g.pinch && a.length >= 2) {
      var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1;
      var ns = clamp(g.s0 * d / g.d0, MIN, MAX);
      var mx = (a[0].x + a[1].x) / 2, my = (a[0].y + a[1].y) / 2;
      var px = (g.mx - cx - g.tx0) / g.s0, py = (g.my - cy - g.ty0) / g.s0;
      Z.s = ns;
      Z.tx = mx - cx - px * ns;
      Z.ty = my - cy - py * ns;
      clampT();
      apply();
    } else if (!g.pinch && Z.s > 1.01) {
      Z.tx = g.tx0 + (a[0].x - g.x0);
      Z.ty = g.ty0 + (a[0].y - g.y0);
      clampT();
      apply();
    }
  }
  function onUp(e) {
    if (!isOpen) return;
    if (e.pointerType === 'mouse') {
      if (e.type !== 'pointerup' || !tap) return;
      var t = tap; tap = null;
      if (t.moved || !inBox(e.clientX, e.clientY)) return;
      if (Z.s > 1.01) reset('anim');
      else { Z.s = ZOOM; follow(e.clientX, e.clientY); apply('anim'); }
      return;
    }
    if (!pts[e.pointerId]) return;
    delete pts[e.pointerId];
    nPts = list().length;
    if (Z.s < 1.03 && nPts === 0) { Z.s = 1; Z.tx = 0; Z.ty = 0; apply('anim'); }
    startGesture();
    if (nPts === 0 && tap && e.type === 'pointerup') {
      var tp = tap; tap = null;
      if (tp.moved || Date.now() - tp.t > 350) return;
      var now = Date.now();
      if (lastTap && now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40 && inBox(e.clientX, e.clientY)) {
        lastTap = null;
        if (Z.s > 1.01) reset('anim'); else zoomAt(ZOOM, e.clientX, e.clientY, 'anim');
      } else lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  }

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); Z.s = ZOOM; Z.tx = 0; Z.ty = 0; apply('anim'); }
    if (e.key === '-' || e.key === '0') { e.preventDefault(); reset('anim'); }
  }

  /* ---- content ---- */
  function bigUrl(u) {
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=2000');
    u = u.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-z]{3,4}(\?|$))/i, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
  }
  function visibleMockup(stage, hit) {
    var m = hit && hit.closest && hit.closest('.tee-platform-mockup');
    if (m && stage.contains(m) && !m.closest('.tee-thumbnails')) return m;
    var sr = stage.getBoundingClientRect(), cx = sr.left + sr.width / 2, cy = sr.top + sr.height / 2, best = null, bd = Infinity;
    stage.querySelectorAll('.tee-platform-mockup').forEach(function (el) {
      if (el.closest('.tee-thumbnails')) return;
      var r = el.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) return;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') < 0.1) return;
      var d = Math.hypot(r.left + r.width / 2 - cx, r.top + r.height / 2 - cy);
      if (d < bd) { bd = d; best = el; }
    });
    return best;
  }
  function cloneMockup(m, S) {
    var w = m.offsetWidth || m.getBoundingClientRect().width, h = m.offsetHeight || m.getBoundingClientRect().height;
    if (!w || !h) return null;
    var k = S / Math.max(w, h);
    var c = m.cloneNode(true);
    try {
      var sa = [m].concat(Array.prototype.slice.call(m.querySelectorAll('*')));
      var da = [c].concat(Array.prototype.slice.call(c.querySelectorAll('*')));
      for (var i = 0; i < sa.length && i < da.length; i++) {
        var s = sa[i], d = da[i], cs = getComputedStyle(s), css = '';
        for (var j = 0; j < PROPS.length; j++) {
          var v = cs.getPropertyValue(PROPS[j]);
          if (v) css += PROPS[j] + ':' + v + ';';
        }
        d.style.cssText = css + 'transition:none;animation:none;';
        d.removeAttribute('id');
        if (s.tagName === 'CANVAS') {
          try { d.width = s.width; d.height = s.height; d.getContext('2d').drawImage(s, 0, 0); } catch (err) {}
        } else if (s.tagName === 'IMG') {
          d.loading = 'eager';
          if (d.srcset) d.sizes = Math.min(2400, Math.round(S * 2)) + 'px';
        }
      }
    } catch (err) {}
    c.style.position = 'relative';
    c.style.left = '0'; c.style.top = '0'; c.style.right = 'auto'; c.style.bottom = 'auto';
    c.style.margin = '0';
    c.style.transform = 'none';
    c.style.opacity = '1';
    c.style.visibility = 'visible';
    c.style.width = w + 'px'; c.style.height = h + 'px';
    var wrap = document.createElement('div');
    wrap.className = 'kl-zm__mk';
    wrap.style.width = w + 'px';
    wrap.style.height = h + 'px';
    wrap.style.transform = 'scale(' + k + ')';
    wrap.appendChild(c);
    BW = Math.round(w * k); BH = Math.round(h * k);
    return wrap;
  }

  function open(stage, hit) {
    build();
    var vw = window.innerWidth, vh = window.innerHeight;
    var S = Math.floor(Math.min(vw * 0.92, vh * 0.92));
    pan.innerHTML = '';
    var gal = stage.closest('media-gallery') || stage;
    var view = stage.querySelector('.kl-gx-view.is-on');
    var node = null;
    if (view && gal.classList.contains('kl-gx--ext')) {
      var vi = view.querySelector('img');
      if (vi && (vi.currentSrc || vi.src)) {
        var img = document.createElement('img');
        img.className = 'kl-zm__img';
        img.alt = vi.alt || '';
        img.decoding = 'async';
        img.src = vi.currentSrc || vi.src;
        var hi = bigUrl(vi.src || vi.currentSrc);
        if (hi && hi !== img.src) {
          var pre = new Image();
          pre.onload = function () { if (img.isConnected) img.src = hi; };
          pre.src = hi;
        }
        BW = BH = S;
        node = img;
        src = 'photo';
      }
    }
    if (!node) {
      var m = visibleMockup(stage, hit);
      if (!m) return;
      node = cloneMockup(m, S);
      if (!node) return;
      src = 'mockup';
    }
    box.style.width = BW + 'px';
    box.style.height = BH + 'px';
    pan.appendChild(node);
    var touch = false;
    try { touch = window.matchMedia('(hover: none), (pointer: coarse)').matches; } catch (e) {}
    hint.textContent = touch ? 'Pinch or double-tap to zoom' : 'Click to zoom · Esc to close';
    Z.s = 1; Z.tx = 0; Z.ty = 0; apply();
    pts = {}; nPts = 0; g = null; tap = null; lastTap = null;
    lastFocus = document.activeElement;
    htmlOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('kl-zm-open');
    isOpen = true;
    void ov.offsetWidth;
    ov.classList.add('is-open');
    try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    ov.classList.remove('is-open', 'is-zoomed');
    document.documentElement.style.overflow = htmlOverflow;
    document.documentElement.classList.remove('kl-zm-open');
    setTimeout(function () { if (!isOpen) pan.innerHTML = ''; }, reduced() ? 0 : 220);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---- triggers (delegated, capture: works whenever Teeinblue mounts) ---- */
  var down = null;
  document.addEventListener('pointerdown', function (e) {
    down = mainStage(e.target) ? { x: e.clientX, y: e.clientY } : null;
  }, true);
  document.addEventListener('click', function (e) {
    if (isOpen) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var stage = mainStage(t);
    if (!stage) return;
    var btn = t.closest('.kl-zm-btn');
    if (!btn) {
      if (t.closest(CONTROLS) || t.closest(SKIP)) return;
      if (down && Math.hypot(e.clientX - down.x, e.clientY - down.y) > 10) return; /* a swipe, not a tap */
      if (!t.closest('.kl-gx-view.is-on') && !t.closest('.tee-platform-mockup')) return;
    }
    e.preventDefault();
    e.stopPropagation();
    open(stage, btn ? null : t);
  }, true);
  document.addEventListener('keydown', onKey, true);
  window.addEventListener('resize', function () { if (isOpen) close(); });

  /* ---- Two-photo products (Cheek to Cheek): "Upload 2 photos" callout + numbered photo icon in each dropzone ----
     Teeinblue markup is not in the theme (app embed), so fields are found by their label text "Photo 1 · …" /
     "Photo 2 · …", walking up to the nearest ancestor that holds an upload control, then the dropzone inside it. */
  var PHOTO_RE = /^\s*Photo\s*([12])\s*[·•]/i;
  var PHOTO_ALL = /Photo\s*[12]\s*[·•]/gi;
  var CARD_SVG = '<svg viewBox="0 0 28 28" width="28" height="28" fill="none" stroke="#1A1D1A" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true" focusable="false"><rect x="4" y="6" width="20" height="16" rx="2"/><circle cx="10" cy="11.5" r="2"/><path d="M5 20l6-5.5 4 3.5 3-2.5 5 4.5"/></svg>';
  var DUO_SVG = '<svg viewBox="0 0 32 32" width="28" height="28" fill="none" stroke="#1A1D1A" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true" focusable="false"><rect x="3" y="9" width="16" height="13" rx="2" transform="rotate(-8 11 15.5)"/><rect x="11" y="6" width="16" height="13" rx="2" fill="#FAF8F4"/><circle cx="16" cy="10.5" r="1.6"/><path d="M12 17l4-3.5 3 2.5 2-1.5 5 4"/><circle cx="25" cy="24.5" r="5" fill="#FAF8F4"/><path d="M25 22v5M22.5 24.5h5"/></svg>';
  var UP_SEL = 'input[type="file"], [class*="upload"], [class*="dropzone"], [class*="drop-zone"]';
  function upOk(c, L) { return c !== L && !c.contains(L) && !L.contains(c) && !c.closest('.kl-up-ico, .kl-up-call'); }
  function hasUpload(el, L) {
    var c = el.querySelectorAll(UP_SEL);
    for (var i = 0; i < c.length; i++) if (upOk(c[i], L)) return true;
    return /choose an image/i.test(el.textContent || '');
  }
  function findField(L) {
    var el = L;
    for (var i = 0; i < 7 && el.parentElement; i++) {
      el = el.parentElement;
      if (el.matches('form, body, .product-details')) return null;
      if (hasUpload(el, L)) return ((el.textContent || '').match(PHOTO_ALL) || []).length <= 1 ? el : null;
    }
    return null;
  }
  function area(el) { var r = el.getBoundingClientRect(); return r.width * r.height; }
  function findDrop(F, L) {
    var best = null, ba = -1;
    F.querySelectorAll('[class*="dropzone"], [class*="drop-zone"], [class*="upload"]').forEach(function (c) {
      if (c.tagName === 'INPUT' || !upOk(c, L)) return;
      var a = area(c);
      if (a > ba) { ba = a; best = c; }
    });
    if (best) return best;
    var f = F.querySelector('input[type="file"]');
    if (f && f.parentElement && upOk(f.parentElement, L)) return f.parentElement;
    var w = document.createTreeWalker(F, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (/choose an image/i.test(n.nodeValue || '') && n.parentElement) {
        var p = n.parentElement.closest('button, [role="button"]') || n.parentElement;
        return p.parentElement && upOk(p.parentElement, L) ? p.parentElement : p;
      }
    }
    return null;
  }
  function decorateDrop(D, F, num) {
    var has = false;
    F.querySelectorAll('img').forEach(function (im) { if (!im.closest('.kl-up-ico') && (im.currentSrc || im.src)) has = true; });
    D.classList.toggle('kl-up-has', has);
    D.classList.add('kl-up-dz');
    var ico = D.querySelector('.kl-up-ico');
    if (ico) { var nn = ico.querySelector('.kl-up-ico__n'); if (nn && nn.textContent !== num) nn.textContent = num; return; }
    try { if (getComputedStyle(D).position === 'static') D.style.position = 'relative'; } catch (e) {}
    ico = document.createElement('span');
    ico.className = 'kl-up-ico';
    ico.setAttribute('aria-hidden', 'true');
    ico.innerHTML = CARD_SVG + '<span class="kl-up-ico__n">' + num + '</span>';
    var plus = null;
    var all = D.querySelectorAll('svg, i, span, [class*="plus"], [class*="icon"]');
    for (var i = 0; i < all.length && !plus; i++) {
      var c = all[i];
      if (c.closest('.kl-up-ico') || c.querySelector('input')) continue;
      var cls = String(c.getAttribute('class') || '');
      if (/plus/i.test(cls) || (c.textContent || '').trim() === '+') { plus = c; break; }
      if (c.tagName.toLowerCase() === 'svg') { var r = c.getBoundingClientRect(); if (r.width && r.width <= 48 && r.height <= 48) plus = c; }
    }
    if (plus && plus.parentNode) { plus.classList.add('kl-up-plus'); plus.parentNode.insertBefore(ico, plus); }
    else D.insertBefore(ico, D.firstChild);
  }
  function scanUploads() {
    var body = document.body;
    if (!body || !/Photo\s*2\s*[·•]/i.test(body.textContent || '')) return;
    var fields = {};
    var w = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var m = PHOTO_RE.exec(n.nodeValue || '');
      if (!m || fields[m[1]]) continue;
      var L = n.parentElement;
      if (!L || L.closest('script, style, .kl-zm, .kl-up-call, product-card, .product-card, [class*="cropper"], [class*="modal"], [class*="lightbox"]')) continue;
      var F = findField(L);
      if (F) fields[m[1]] = { F: F, L: L };
    }
    if (!fields['1'] || !fields['2']) return;
    ['1', '2'].forEach(function (k) {
      var D = findDrop(fields[k].F, fields[k].L);
      if (D) decorateDrop(D, fields[k].F, k);
    });
    var F1 = fields['1'].F, call = F1.previousElementSibling;
    if (!call || !call.classList.contains('kl-up-call')) {
      call = document.createElement('div');
      call.className = 'kl-up-call';
      call.setAttribute('role', 'note');
      call.innerHTML = DUO_SVG + '<span>Upload 2 photos — one for each face</span>';
      F1.parentNode.insertBefore(call, F1);
    }
    document.querySelectorAll('.kl-up-call').forEach(function (c) { if (c !== call) c.remove(); });
  }

  var scanT = null;
  function scan() { clearTimeout(scanT); scanT = setTimeout(function () { addButtons(); tagConfirm(); scanUploads(); }, 120); }
  function boot() {
    scan();
    try { new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
